module.exports = __webpack_public_path__ + "static/img/img-empleabilidad-3c0e17f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-empleabilidad.png
// module id = xTCD
// module chunks = 1